import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_URL } from "@/lib/api";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/service-areas", label: "Service Areas" },
  { to: "/referral-partners", label: "Partners" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-slate-100" data-testid="site-navbar">
      <div className="container-x flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo-link">
          <img src={LOGO_URL} alt="Melo Hopeful Care" className="h-12 w-12 object-contain" />
          <div className="leading-tight hidden sm:block">
            <div className="font-heading font-semibold text-[15px] text-slate-900">Melo Hopeful Care</div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-teal-700">The Heart of Home Care</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? "bg-slate-900 text-white"
                    : "text-slate-700 hover:text-brand-navy hover:bg-slate-100"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a href="tel:+14027611531" className="hidden md:inline-flex items-center gap-2 text-sm font-medium text-slate-700 hover:text-brand-navy" data-testid="navbar-phone">
            <Phone className="w-4 h-4 text-teal-600" strokeWidth={1.75} /> (402) 761-1531
          </a>
          <Link to="/request-care" className="btn-primary hidden sm:inline-flex" data-testid="navbar-request-care-btn">
            Request Care
          </Link>
          <button className="lg:hidden p-2 rounded-full hover:bg-slate-100" onClick={() => setOpen(!open)} aria-label="menu" data-testid="navbar-menu-toggle">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white" data-testid="navbar-mobile-menu">
          <div className="container-x py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-xl text-sm font-medium ${
                    isActive ? "bg-slate-900 text-white" : "text-slate-700 hover:bg-slate-100"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/request-care" onClick={() => setOpen(false)} className="btn-primary mt-2" data-testid="navbar-mobile-request-care-btn">
              Request Care
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
